import { render, staticRenderFns } from "./GlobalMessagingSettings.vue?vue&type=template&id=6ec3cea9"
import script from "./GlobalMessagingSettings.vue?vue&type=script&lang=js"
export * from "./GlobalMessagingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports